module.exports = __webpack_public_path__ + "img/tuurro.t6.f7.ff260e0d.png";